import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import { Provider } from 'react-redux';

import store from './store';
import {
	changeLayout,
	changeLayoutMode,
	changeSidebarTheme,
	changeTopbarTheme,
	setUserDataFromLocalStorage,
	startTokenWatcher
} from 'store/actions';

const root = ReactDOM.createRoot(document.getElementById('root'));

const userData = localStorage.getItem('authUser');
if (userData) {
	store.dispatch(startTokenWatcher());
	store.dispatch(setUserDataFromLocalStorage(JSON.parse(userData)));
	let getUserData = JSON.parse(userData);
	if (getUserData.themeData) {
		store.dispatch(changeLayout(getUserData.themeData.layouts));
		store.dispatch(changeLayoutMode(getUserData.themeData.layoutMode));
		store.dispatch(changeTopbarTheme(getUserData.themeData.topBarTheme));
		store.dispatch(changeSidebarTheme(getUserData.themeData.sidebarTheme));
	}
}
root.render(
	<Provider store={store}>
		<React.Fragment>
			<BrowserRouter>
				<App store={store} />
			</BrowserRouter>
		</React.Fragment>
	</Provider>
);
